import 'bootstrap/dist/css/bootstrap.min.css';
import NavbarComponent from './Components/NavbarComponent';

function App() {
  return (
    <div className="App">
      <NavbarComponent/>
    </div>
  );
}

export default App;
